import * as types from '../actions/types';


const initialPlannedState = {
  //@ts-ignore  
  vehiclesData: []
};
//@ts-ignore
export const vehicleReducer = function (state = initialPlannedState, action) {
  switch (action.type) {
  case types.SET_VEHICLE_LOADCLASS:
    return {
      ...state,
      load_classes: action.data
    };
  case types.SET_VEHICLES_DATA:
    return {
      ...state,
      vehiclesData: action.data
    };

  default:
    return state;
  }
};
